import React from "react"
import PropTypes from "prop-types"

import theme from "styles/theme"
import ResourceCard from "components/cards/ResourceCard"

const ResourceBlock = ({ gridSubhead, resources }) => (
  <div
    css={{
      maxWidth: 1140,
      margin: "40px auto 0",
    }}
  >
    {gridSubhead && (
      <h4
        css={{
          ...theme.t6,
          color: theme.softGray,
          marginBottom: 30,
          textAlign: "center",
          [theme.mobile]: {
            marginBottom: 24,
          },
        }}
      >
        {gridSubhead}
      </h4>
    )}
    <div
      css={{
        display: "grid",
        gridTemplateColumns: gridRepeat(resources.length, 3),
        justifyContent: "center",
        gridGap: 35,
        [theme.tablet]: {
          gridTemplateColumns: gridRepeat(resources.length, 2),
          gridGap: 10,
        },
        [theme.mobile]: {
          gridTemplateColumns: "minmax(auto, 354px)",
          gridGap: 15,
        },
      }}
    >
      {resources.map((item, index) => (
        <ResourceCard key={index} {...item} />
      ))}
    </div>
  </div>
)

const gridRepeat = (n, max) =>
  `repeat(${n === 4 ? 2 : Math.min(n, max)}, minmax(auto, 354px))`

ResourceBlock.propTypes = {
  gridSubhead: PropTypes.string,
  resources: PropTypes.arrayOf(PropTypes.shape(ResourceCard.propTypes))
    .isRequired,
}

export default ResourceBlock
